import React from "react";
import { motion } from "framer-motion";
import { TagCloud } from "@frank-mayer/react-tag-cloud";

const skills = [
  "HTML",
  "CSS",
  "React.js",
  "Node.js",
  "Swift",
  "Bootstrap",
  "Javascript",
  "Framer Motion",
  "GIT",
  "GITHUB",
  "Spline",
  "Figma",
];

const skillCategories = [
  { title: "Frontend", skills: ["React.js", "Javascript", "HTML", "CSS", "Bootstrap"] },
  { title: "Backend & Tools", skills: ["Node.js", "Swift", "GIT", "GITHUB"] },
  { title: "Design & Animation", skills: ["Framer Motion", "Spline", "Figma"] },
];

const Technologies = () => {
  const [cloudOptions, setCloudOptions] = React.useState({
    radius: 300,
    maxSpeed: "fast",
  });

  React.useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 992px)");

    const updateCloudOptions = () => {
      setCloudOptions({
        radius: mediaQuery.matches ? 150 : 300,
        maxSpeed: "fast",
      });
    };

    updateCloudOptions();
    mediaQuery.addEventListener("change", updateCloudOptions);
    return () => mediaQuery.removeEventListener("change", updateCloudOptions);
  }, []);

  return (
    <div className="skills-section">
      <motion.h1
        className="skills-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Skills<span className="skills-dot">.</span>
      </motion.h1>
      <motion.div
        className="skills-bento-grid"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      >
        <div className="skills-card bento-cloud">
          <TagCloud
            className="skills-tagcloud"
            options={cloudOptions}
            onClickOptions={{ passive: true }}
          >
            {skills}
          </TagCloud>
        </div>
        <div className="skills-card bento-text">
          <h2 className="skills-card-title">Background</h2>
          <p className="skills-card-text">
            My area of expertise is in Front-End Web Development, with
            additional experience in iOS App Development. For medium and large
            scale web applications, my preferred technologies include HTML,
            CSS, Javascript and React.js. I also use Node.js for API
            implementations.
          </p>
        </div>
        {skillCategories.map((cat) => (
          <div className="skills-card bento-category" key={cat.title}>
            <h3 className="category-title">{cat.title}</h3>
            <div className="skills-tags">
              {cat.skills.map((skill) => (
                <span key={skill} className="skills-tag">{skill}</span>
              ))}
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Technologies;
